import { typesenseAdapter } from "./typesense-adapter";
import { searchActionHeaders } from "./search-action";
import { handleTypesenseGatewayError } from "./rate-limit";

export function searchClient(query_by, inFix, token, serverType, sort_by) {
  const initialAdapter = typesenseAdapter(query_by, inFix, token, serverType, sort_by);
  const baseClient = initialAdapter.searchClient;

  // Wrap the client so that when query is "*" we sort by newest first; otherwise use relevance
  const wrappedClient = {
    ...baseClient,
    async search(requests) {
      try {
        const adjusted = requests.map((req) => {
          const params = req?.params || {};
          const q = params.query ?? params.q;
          // Only inject sort for wildcard searches when no explicit sort is already set
          if (q === "*" && !params.sort_by) {
            return {
              ...req,
              params: { ...params, sort_by: "date:desc" },
            };
          }
          return req;
        });
        const query = adjusted?.[0]?.params?.query ?? adjusted?.[0]?.params?.q ?? "";
        const headers = {
          ...searchActionHeaders(query, serverType === "dictionary" ? "dictionary" : "case_search"),
          ...(token && token !== "noToken" ? { Authorization: `Bearer ${token}` } : {}),
        };
        const requestClient = typesenseAdapter(query_by, inFix, token, serverType, sort_by, headers).searchClient;
        return await requestClient.search(adjusted);
      } catch (error) {
        throw handleTypesenseGatewayError(error);
      }
    },
  };

  return wrappedClient;
}
